import React from "react";
import { Paper, Typography, Box } from "@mui/material";
import { Bar } from "react-chartjs-2";

const CustomBarChart = ({
  title,
  data,
  labels,
  selectedIndex,
  colors,
  onClick,
  height = 250,
}) => {
  const chartOptions = {
    indexAxis: "y",
    responsive: true,
    maintainAspectRatio: false,
    onClick,
    onHover: (event, chartElements) => {
      event.native.target.style.cursor = chartElements.length
        ? "pointer"
        : "default";
    },
    scales: {
      x: {
        grid: {
          display: true,
          color: "#f0f0f0",
        },
        ticks: {
          font: {
            size: 12,
          },
        },
      },
      y: {
        grid: {
          display: false,
        },
        ticks: {
          font: {
            size: 12,
          },
          // Add ellipsis for long labels
          callback: function (value) {
            const label = this.getLabelForValue(value);
            return label.length > 20 ? label.substring(0, 17) + "..." : label;
          },
        },
      },
    },
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        // Customize tooltip to show full text
        callbacks: {
          title: function (tooltipItems) {
            return labels[tooltipItems[0].dataIndex];
          },
          label: function (context) {
            return `Views: ${context.raw}`;
          },
        },
        titleFont: {
          size: 14,
        },
        padding: 10,
        cornerRadius: 4,
        backgroundColor: "rgba(50, 50, 50, 0.9)",
      },
    },
    animation: {
      duration: 500,
    },
    hover: {
      animationDuration: 0, // Disable animation when hovering for smoother experience
      mode: "nearest",
      intersect: true,
    },
  };

  const chartData = {
    labels: labels,
    datasets: [
      {
        data: data,
        backgroundColor: (context) => {
          const index = context.dataIndex;
          return index === selectedIndex ? colors.selectedBg : colors.defaultBg;
        },
        borderColor: (context) => {
          const index = context.dataIndex;
          return index === selectedIndex
            ? colors.selectedBorder
            : "transparent";
        },
        borderWidth: (context) => {
          const index = context.dataIndex;
          return index === selectedIndex ? 2 : 0;
        },
        borderRadius: 4,
        barThickness: 20,
        hoverBackgroundColor: colors.hoverBg,
      },
    ],
  };

  return (
    <Paper
      elevation={3}
      sx={{
        p: 2,
        height: "100%",
        minHeight: "300px",
        "& h6": {
          fontSize: "0.875rem",
          fontWeight: 500,
          color: "#374151",
          mb: 2,
        },
      }}
    >
      <Typography variant="h6">{title}</Typography>
      <div style={{ height: height }}>
        <Bar data={chartData} options={chartOptions} />
      </div>
    </Paper>
  );
};

export default CustomBarChart;
